import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    emoji: '🟢',
    name: 'Tomo 1 — Formación Base U10/U12',
    desc: '25 sesiones modelo · Fundamentos, psicomotricidad y amor por el deporte construido desde la primera sesión.'
  }, {
    emoji: '🟡',
    name: 'Tomo 2 — Desarrollo U13/U15',
    desc: '25 sesiones modelo · Técnica, sistemas de juego básicos y gestión de la pubertad.'
  }, {
    emoji: '🟠',
    name: 'Tomo 3 — Perfeccionamiento U17/U19',
    desc: '25 sesiones modelo · Sistema 5-1, especialización por posición y análisis táctico del rival.'
  }, {
    emoji: '🔴',
    name: 'Tomo 4 — Preparación Física',
    desc: 'Potencia de salto en 8 semanas · Fuerza sin gimnasio · Prevención de lesiones · Nutrición deportiva básica.'
  }, {
    emoji: '🟣',
    name: 'Tomo 5 — 101 Drills Pro',
    desc: 'Biblioteca completa de 101 ejercicios organizados por categoría, nivel y posición. Más de 200 variantes incluidas.'
  }, {
    emoji: '⭐',
    name: 'Tomo 6 — Gestión y Liderazgo',
    desc: 'Comunicación con padres · Psicología de equipo · Planificación anual · Cómo construir un programa de prestigio.'
  }];
  const features = ['Planificación anual lista para usar', 'Sesiones con objetivo, desarrollo y cierre', 'Sistema Abrir y Entrenar: lees 3 minutos antes de entrar', 'Fichas de progreso y evaluación por jugador', 'Variantes para nivel más fácil y más difícil', 'Material original EDULABS'];
  return <section className="py-20 px-4 bg-dark-DEFAULT" data-id="element-273">
      <div className="max-w-6xl mx-auto" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <h2 className="text-5xl md:text-6xl font-bebas mb-4" data-id="element-276">
            <span className="text-white" data-id="element-277">Los 6 Tomos </span>
            <span className="text-brand-DEFAULT" data-id="element-278">Completos</span>
          </h2>
          <p className="text-xl text-text-secondary font-medium" data-id="element-279">
            Por nivel y categoría · 150 sesiones · Evaluación incluida
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-280">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl hover:border-brand-DEFAULT/50 transition-colors" data-id="element-281">
              <div className="text-4xl mb-4" data-id="element-282">{tomo.emoji}</div>
              <h3 className="text-2xl font-bebas text-brand-DEFAULT mb-3 tracking-wide" data-id="element-283">
                {tomo.name}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-284">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-xl p-8 md:p-12" data-id="element-285">
          <h3 className="text-3xl font-bebas text-white mb-8 text-center" data-id="element-286">
            CARACTERÍSTICAS INCLUIDAS EN CADA TOMO:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-287">
            {features.map((feature, index) => <div key={index} className="flex items-start space-x-3" data-id="element-288">
                <div className="bg-dark-border p-1 rounded-full mt-0.5" data-id="element-289">
                  <CheckIcon size={16} className="text-brand-DEFAULT" data-id="element-290" />
                </div>
                <span className="text-white" data-id="element-291">{feature}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}